export default __webpack_public_path__ + "static/media/medium.4eebd723.svg";